import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	statistic: {
		id: 'issue-field-statistics.numeric-stats-container.numeric-stats-table.statistic',
		defaultMessage: 'Statistic',
		description: 'Column header for the statistic name i.e. mean, maximum, minimum etc...',
	},
	value: {
		id: 'issue-field-statistics.numeric-stats-container.numeric-stats-table.value',
		defaultMessage: 'Value',
		description: 'Column header for the statistic value',
	},
	minimum: {
		id: 'issue-field-statistics.numeric-stats-container.numeric-stats-table.minimum',
		defaultMessage: 'Min',
		description: 'The minimum value for this field across all issues',
	},
	maximum: {
		id: 'issue-field-statistics.numeric-stats-container.numeric-stats-table.maximum',
		defaultMessage: 'Max',
		description: 'The maximum value for this field across all issues',
	},
	sum: {
		id: 'issue-field-statistics.numeric-stats-container.numeric-stats-table.sum',
		defaultMessage: 'Sum',
		description: 'The sum total value for this field across all issues',
	},
	count: {
		id: 'issue-field-statistics.numeric-stats-container.numeric-stats-table.count',
		defaultMessage: 'Total issue count',
		description: 'The count of issues',
	},
});
